<template>
<div class="site container hfeed">
  <HeadNav selectedLanguage="en" page="guides" />
  <article class="seo-topic-page">
    <SeoBreadcrumb :items="breadcrumbItems" />
    <section class="blog-content">
      <h1>GB WhatsApp Guides</h1>
      <p>Explore GB WhatsApp guides for backup, updates, chat transfer, installation, and feature tutorials. Get practical solutions for common issues.</p>

      <div class="guides-list">
        <router-link
          v-for="post in sortedGuidePosts"
          :key="post.path"
          :to="post.path"
          class="guides-list__item"
        >
          <div class="guides-list__img">
            <img :src="post.poster" :alt="post.title">
          </div>
          <div class="guides-list__body">
            <h2 class="guides-list__title">{{ post.title }}</h2>
            <p class="guides-list__desc">{{ post.desc }}</p>
            <time class="guides-list__date" :datetime="post.date">{{ post.date }}</time>
          </div>
        </router-link>
      </div>
    </section>
  </article>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/seo-guide-page.scss';
import '@/css/gb-wave-home.scss';
import HeadNav from '@/components/HeadNav.vue';
import SeoBreadcrumb from '@/components/SeoBreadcrumb.vue';
import { guidePosts } from '@/documents/guides.js';

export default {
  name: 'GuidesHub',
  components: { HeadNav, SeoBreadcrumb },
  data() {
    return {
      breadcrumbItems: [
        { label: 'Home', to: { name: 'en-gb' } },
        { label: 'Guides', current: true },
      ],
    };
  },
  computed: {
    // 按日期倒序：最新文章在前
    sortedGuidePosts() {
      return [...guidePosts].sort((a, b) => String(b.date).localeCompare(String(a.date)));
    },
  },
};
</script>

<style scoped>
.guides-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 1.5rem;
}

.guides-list__item {
  display: flex;
  gap: 16px;
  padding: 16px;
  border: 1px solid #e6ebe8;
  border-radius: 14px;
  text-decoration: none;
  color: inherit;
  background: #fff;
  overflow: hidden;
  transition:
    background 0.2s ease,
    transform 0.25s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.25s ease,
    border-color 0.25s ease;
}

.guides-list__item:hover {
  background: #f8faf9;
  transform: translateY(-2px);
  border-color: #cfe8d7;
  box-shadow: 0 14px 30px rgba(18, 76, 43, 0.1);
}

.guides-list__img {
  flex-shrink: 0;
  width: 180px;
  border-radius: 8px;
  overflow: hidden;
  background: #0b3d2a;
}

.guides-list__img img {
  width: 100%;
  height: 102px;
  object-fit: cover;
  display: block;
  transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}

.guides-list__item:hover .guides-list__img img {
  transform: scale(1.04);
}

.guides-list__body {
  flex: 1;
  min-width: 0;
}

.guides-list__title {
  font-size: 1.15rem;
  margin: 0 0 8px;
  color: #0d3d2a;
  line-height: 1.35;
}

.guides-list__desc {
  margin: 0;
  color: #555;
  font-size: 0.95rem;
  line-height: 1.5;
}

.guides-list__date {
  display: inline-block;
  margin-top: 10px;
  font-size: 0.85rem;
  color: #888;
}

@media (max-width: 640px) {
  .guides-list__item {
    flex-direction: column;
  }

  .guides-list__img {
    width: 100%;
  }

  .guides-list__img img {
    height: 140px;
  }
}
</style>
